import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Clipboard: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 3.25a.75.75 0 00-.75.75v.25H5.5A1.25 1.25 0 004.25 5.5v14a1.25 1.25 0 001.25 1.25h13a1.25 1.25 0 001.25-1.25v-14a1.25 1.25 0 00-1.25-1.25h-3.75V4a.75.75 0 00-.75-.75h-4zm4.75 2.5V7a.75.75 0 01-.75.75h-4A.75.75 0 019.25 7V5.75h-3.5v13.5h12.5V5.75h-3.5zm-1.5.5h-2.5v-1.5h2.5v1.5z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 11.75h-5v-1.5h5v1.5zM16 15.75h-5v-1.5h5v1.5z'
        fill='currentColor'
      />
      <path
        d='M10 11a1 1 0 11-2 0 1 1 0 012 0zM10 15a1 1 0 11-2 0 1 1 0 012 0z'
        fill='currentColor'
      />
    </svg>
  </i>
);

Clipboard.displayName = 'Clipboard';
export default Clipboard;
